import { render, staticRenderFns } from "./teacherSelect.vue?vue&type=template&id=5c969d95"
import script from "./teacherSelect.vue?vue&type=script&lang=js"
export * from "./teacherSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports